import {
  Component,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { FirmenService } from '@app/services/firmen.service';
import { FirmaDto } from '@app/dto/firma.dto';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { map, mergeMap, forkJoin, mergeAll, toArray } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { FirmenstandorteService } from '@app/services/firmenstandorte.service';
import { NewFirmenHauptstandortDto } from '@app/dto/newFirmenhauptstandort.dto';
import { PcAdressenService } from '@app/services/pcadressen.service';
import { action } from './action.model';
import { MatLegacyTable as MatTable, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { PcAdresseUmhaengenDto } from '@app/dto/pcadresse.umhaengen.dto';
import { FirmenstandortDto } from '@app/dto/firmenstandort.dto';
import { TransactionDto } from '@app/dto/transaction.dto';
import { FirmenstandorteIndexResultElement } from '@app/dto/firmenstandorte.index.result-element.dto';
import { expandableRowAnimation } from "../firmen/expandable-row.animation";
import { ValidatorsService } from "@app/services/validators.service";
import { UserService } from "@app/services/user.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {FirmenIndexFirmaDto} from "@app/dto/firmen.index.firma.dto";
import {LegacyPageEvent as PageEvent} from "@angular/material/legacy-paginator";

declare var window: any;

interface PcAdresseElement {
  firmenId: number;
  firmenname: string;
  firmenstandortId: number;
  actions: action[]
  pcAdresseId: number;
  pcAdressnummer: number;
  nlCode: string;
  beDirectId: number;
  originalFirmenname: string;
  strasseUndHausnummer: string;
  plz: string;
  ort: string;
  laendercode: string;
  canBeMoved: boolean;
}

interface FirmenstandortElement {
  id?: number;
  firmenId?: number;
  firmenstandortId?: number;
  beDirectId?: number;
  istFirmenhauptstandort?: boolean;
  salesforceId?: string;
  strasseUndHausnummer?: string;
  plz?: string;
  ort?: string;
  laendercode?: string;
  telefon?: string;
  fax?: string;
  email?: string;
  betriebsgroesse?: string;
  betriebsgroesseGewerblich?: string;
  betriebsgroesseKaufmaennisch?: string;
  istGeloescht?: boolean;
  actions: action[];
  pcAdressen?: PcAdresseElement[];
  transactions?: TransactionDto[];
}

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.scss'],
  animations: [expandableRowAnimation],
  encapsulation: ViewEncapsulation.None
})
export class FirmaComponent implements OnInit {

  firmenElement?: FirmaDto;
  firmenStandorte: Array<FirmenstandortDto> = [];
  firmenId!: number;

  private urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  private numericPattern = '^[0-9]*$';

  public editFirmaDatenForm = new FormGroup({
    firmenname:           new FormControl('', [Validators.required]),
    branchenzuschlag:     new FormControl('kein Branchenzuschlag'),
    branchencodeWz1979:   new FormControl(''),
    branchencodeWz2008:   new FormControl(''),
    lieferantVonBranche:  new FormControl('0 - To be clarified'),
    waehrungscode:        new FormControl('EUR'),
    webseiteHomepage:     new FormControl('')
  });

  editFirmaDatenModal: any;

  public editStandortDatenForm = new FormGroup({
    strasseUndHausnummer:         new FormControl('', [Validators.required]),
    plz:                          new FormControl('', [Validators.required, this.validatorsService.plzValidator('laendercode')]),
    ort:                          new FormControl('', [Validators.required]),
    laendercode:                  new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern("^[A-Za-z]*$")]),
    telefon:                      new FormControl(''),
    fax:                          new FormControl(''),
    email:                        new FormControl(''),
    betriebsgroesse:              new FormControl('ungeklärt'),
    betriebsgroesseGewerblich:    new FormControl('ungeklärt'),
    betriebsgroesseKaufmaennisch: new FormControl('ungeklärt'),
  });

  editStandortDatenModal: any;

  public pcAdrNeueFirmaDatenForm = new FormGroup({
    firmenname:           new FormControl('', [Validators.required]),
    strasseUndHausnummer: new FormControl('', [Validators.required]),
    plz:                  new FormControl('', [Validators.required, this.validatorsService.plzValidator('laendercode')]),
    ort:                  new FormControl('', [Validators.required]),
    laendercode:          new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern("^[A-Za-z]*$")]),
  });

  pcAdrNeueFirmaDatenModal: any;

  public pcAdrNeuerStandortDatenForm = new FormGroup({
    //firmenname:           new FormControl('', [Validators.required]),
    strasseUndHausnummer: new FormControl('', [Validators.required]),
    plz:                  new FormControl('', [Validators.required, this.validatorsService.plzValidator('laendercode')]),
    ort:                  new FormControl('', [Validators.required]),
    laendercode:          new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern("^[A-Za-z]*$")]),
  });

  public pcAdrAndereFirmaSuchForm: FormGroup = new FormGroup({
    searchFirmenname:         new FormControl(''),
    searchFirmenId:           new FormControl(''),
    pcAdrAndereFirmaSelected: new FormControl([]),
  })

  pcAdrMode: string = '';
  pcAdrStandortMode: string = '';

  pcAdrNeuerStandortDatenModal: any;
  pcAdrVorhandenerStandortDatenModal: any;

  selectPcAdresseZuordnenModal: any;
  currentPcAdresse!: PcAdresseElement | null;

  pcAdrAndereFirmaDatenModal: any;

  pcAdrAndereFirmaDataSource: any;
  pcAdrDisplayedAndereFirmaColumns: string[] = [
    'firmenname',
    'firmenId',
    'strasseUndHausnummer',
    'plz',
    'ort',
    'pcAdrAndereFirmaSelected',
  ];
  pcAdrAndereFirmaResultListLength = 0;
  pcAdrAndereFirmaPageSize = 5;

  pcAdrAndereFirmenstandorteDataSource: any;
  pcAdrDisplayedAndereFirmenstandorteColumns: string[] = [
    'info',
    'selectAndererFirmenstandort',
  ];

  successModal: any;
  successMsg:   string = '';
  errorModal:   any;
  errorMsg:     string = '';

  displayedFirmaColumns: string[] = [
    'firmenname',
    'firmenId',
    'crefonummer',
    'action'
  ];

  displayedHauptstandortColumns: string[] = ['hauptstandort', 'actions']
  displayedFirmenstandortColumns: string[] = ['standort', 'actions']

  initColumns = [
    {
      name: 'pcAdressnummer',
      label: 'PcAdresse',
    },
    {
      name: 'nlCode',
      label: 'NlCode',
    },
    {
      name: 'firmenname',
      label: 'Name',
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
    },
    {
      name: 'plz',
      label: 'PLZ',
    },
    {
      name: 'ort',
      label: 'Ort',
    },
    {
      name: 'laendercode',
      label: 'Land',
    },
  ];

  historyDisplayedColumns: string[] = [
    'datum',
    'uhrzeit',
    'transactionId',
    'aktion',
    'kommentar',
    'user'
  ];

  displayedPcAdresseColumns = this.initColumns.map(col => col.name);
  displayedPcAdresseColumnsWithActions: string[] = [...this.displayedPcAdresseColumns, 'actions'];

  tableFirmaDataSource: any;
  firmenstandortDataSource!: MatTableDataSource<FirmenstandortElement>;
  hauptstandortDataSource!: MatTableDataSource<FirmenstandortElement>;

  pcAdrVorhandeneStandorteDataSource: any;
  displayedPcAdrVorhandeneStandorteColumns: string[] = [
    'strasseUndHausnummer',
    'plz',
    'ort',
    'beDirectId',
    'pcAdrVorhandenerStandortSelected',
  ];
  pcAdrVorhandeneStandorteListLength: number = 0;

  currentSelectedStandort!: FirmenstandortDto | null;

  currentSelectedFirma!: FirmenIndexFirmaDto;
  currentSelectedFirmenId!: number | null;
  currentSelectedFirmenstandorteId!: number | null;

  expandedElement!: FirmenstandortElement | null;
  expandedHauptstandortElement!: FirmenstandortElement | null;

  @ViewChildren('innerTables') innerTables = new QueryList<MatTable<PcAdresseElement>>();
  @ViewChildren('innerTableshauptstandort') innerTableshauptstandort = new QueryList<MatTable<PcAdresseElement>>();

  userInfo = this.msalService.instance.getAllAccounts()[0];
  userEmail = this.userInfo && this.userInfo.username ? this.userInfo.username : '';

  filterString: string;
  showAlsoDeletedElements: boolean = false;

  public currentStandortIsHauptstandort: boolean = false;
  public currentStandortId?: number;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator | null;

  constructor(
    private readonly userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private firmenService: FirmenService,
    private firmenstandorteService: FirmenstandorteService,
    private pcAdressenService: PcAdressenService,
    public  dialogNeuePcAdresse: MatDialog,
    private msalService: MsalService,
    private _snackBar: MatSnackBar,
    private validatorsService: ValidatorsService,
    private cd: ChangeDetectorRef
  ) {

    this.firmenId = Number(this.route.snapshot.url[1].path);

    this.filterString = `includeGeloeschte eq ${this.showAlsoDeletedElements}`;

    if (!isNaN(this.firmenId)) {
      this.retrieveFirmaData();
    }
  }

  ngOnInit(): void {
    this.editStandortDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalEditStandortDaten')
    );
    this.editFirmaDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalEditFirmaDaten')
    );

    this.selectPcAdresseZuordnenModal = new window.bootstrap.Modal(
        document.getElementById('modalSelectPcAdresseZuordnen')
    );
    this.pcAdrNeueFirmaDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalPcAdrNeueFirmaDaten')
    );
    this.pcAdrNeuerStandortDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalPcAdrNeuerStandortDaten')
    );
    this.pcAdrVorhandenerStandortDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalPcAdrVorhandenerStandortDaten')
    );
    this.pcAdrAndereFirmaDatenModal = new window.bootstrap.Modal(
        document.getElementById('modalPcAdrAndereFirmaDaten')
    );

    this.successModal = new window.bootstrap.Modal(
        document.getElementById('modalSuccess')
    );
    this.errorModal = new window.bootstrap.Modal(
        document.getElementById('modalError')
    );

    this.editStandortDatenForm.get('laendercode')?.valueChanges.subscribe(() => {
      const plzControl = this.editStandortDatenForm.get('plz');
      plzControl?.updateValueAndValidity();
      plzControl?.markAsTouched();
    });
    this.pcAdrNeueFirmaDatenForm.get('laendercode')?.valueChanges.subscribe(() => {
      const plzControl = this.pcAdrNeueFirmaDatenForm.get('plz');
      plzControl?.updateValueAndValidity();
      plzControl?.markAsTouched();
    });
    this.pcAdrNeuerStandortDatenForm.get('laendercode')?.valueChanges.subscribe(() => {
      const plzControl = this.pcAdrNeuerStandortDatenForm.get('plz');
      plzControl?.updateValueAndValidity();
      plzControl?.markAsTouched();
    });
  }

  retrieveFirmaData() {
    let resultNodeList: FirmenstandortElement[] = [];

    forkJoin({
      firma: this.firmenService.getFirmaById(this.firmenId),
      firmenstandorteData: this.firmenService.getFirmenstandorteByFirmenId(this.firmenId, this.filterString)
          .pipe(
              mergeAll(),
              mergeMap(firmenstandort => this.firmenstandorteService.getPcAdressenByFirmenstandortId(firmenstandort.id, this.filterString)
                  .pipe(
                      mergeAll(),
                      toArray(),
                  ).pipe(
                      map(
                          pcAdressen => (
                              { firmenstandort, pcAdressen }
                          )
                      ),
                  )
              ),
              toArray(),
          )
    }).subscribe(result => {
      if (result.firma) {
        this.tableFirmaDataSource = [
          {
            firmenId:             this.firmenId,
            firmenname:           result.firma.name,
            crefonummer:          result.firma.crefonummer,
            action:               ''
          }
        ]

        this.firmenElement = result.firma;
      }

      if (result.firmenstandorteData) {
        result.firmenstandorteData.forEach(firmenstandortData => {
          if (firmenstandortData.firmenstandort) {
            this.firmenStandorte.push(firmenstandortData.firmenstandort);
          }

          let resultNode: FirmenstandortElement = {
            firmenstandortId:             firmenstandortData.firmenstandort.id,
            beDirectId:                   firmenstandortData.firmenstandort.beDirectId,
            istFirmenhauptstandort:       firmenstandortData.firmenstandort.istFirmenhauptstandort,
            salesforceId:                 firmenstandortData.firmenstandort.salesforceId,
            strasseUndHausnummer:         firmenstandortData.firmenstandort.strasseUndHausnummer,
            plz:                          firmenstandortData.firmenstandort.plz,
            ort:                          firmenstandortData.firmenstandort.ort,
            telefon:                      firmenstandortData.firmenstandort.telefon,
            fax:                          firmenstandortData.firmenstandort.fax,
            email:                        firmenstandortData.firmenstandort.email,
            laendercode:                  firmenstandortData.firmenstandort.laendercode,
            istGeloescht:                 firmenstandortData.firmenstandort.istGeloescht,
            betriebsgroesse:              firmenstandortData.firmenstandort.betriebsgroesse,
            betriebsgroesseGewerblich:    firmenstandortData.firmenstandort.betriebsgroesseGewerblich,
            betriebsgroesseKaufmaennisch: firmenstandortData.firmenstandort.betriebsgroesseKaufmaennisch,
            actions:                      firmenstandortData.firmenstandort.istFirmenhauptstandort ?
              [
                {
                  label: 'Standort-Daten ändern',
                  styleClass: 'bg-gradient-primary',
                  iconClass: 'far fa-edit',
                  functionCall: this.openEditStandortDatenModal,

                },
              ] :
              [
                {
                  label: 'Standort-Daten ändern',
                  styleClass: 'bg-gradient-primary',
                  iconClass: 'far fa-edit',
                  functionCall: this.openEditStandortDatenModal,
                },
                {
                  label: 'Als Hauptstandort deklarieren',
                  styleClass: 'bg-gradient-danger',
                  iconClass: 'fas fa-exclamation',
                  functionCall: this.alsHauptstandortDeklarieren,
                },
              ],
            pcAdressen: [],
          };

          let pcAdressenList: PcAdresseElement[] = [];

          firmenstandortData.pcAdressen.forEach(pcAdresse => {
            let childNode: PcAdresseElement = {
              laendercode: "", originalFirmenname: "", ort: "", plz: "", strasseUndHausnummer: "",
              firmenId:           firmenstandortData.firmenstandort.firmenId ?? 0,
              firmenname:         result.firma.name ?? '',
              firmenstandortId:   firmenstandortData.firmenstandort.id,
              actions:            [],
              pcAdresseId:        pcAdresse.id,
              pcAdressnummer:     pcAdresse.pcAdressnummer,
              nlCode:             pcAdresse.nlCode,
              beDirectId:         firmenstandortData.firmenstandort.beDirectId ?? 0,
              canBeMoved:         !pcAdresse.istGeloescht && pcAdresse.pcAdressnummer !== firmenstandortData.firmenstandort.id
            }

            if (pcAdresse.pcAdressnummer !== pcAdresse.firmenstandorteId && pcAdresse.nlCode && pcAdresse.psDalAnschrift) {
              let firmenname = pcAdresse.psDalAnschrift.name2 ? `${pcAdresse.psDalAnschrift.name1} ${pcAdresse.psDalAnschrift.name2}` : `${pcAdresse.psDalAnschrift.name1}`
              childNode.originalFirmenname    = firmenname;
              childNode.firmenname            = firmenname;
              childNode.strasseUndHausnummer  = `${pcAdresse.psDalAnschrift.strasse} ${pcAdresse.psDalAnschrift.hausnummer}`;
              childNode.plz                   = pcAdresse.psDalAnschrift.plz?.toString();
              childNode.ort                   = pcAdresse.psDalAnschrift.ort;
              childNode.laendercode           = pcAdresse.psDalAnschrift.laendercode;

            } else {
              childNode.originalFirmenname            = pcAdresse.originalFirmenname;
              childNode.firmenname                    = pcAdresse.originalFirmenname;
              childNode.strasseUndHausnummer          = firmenstandortData.firmenstandort.strasseUndHausnummer ?? '';
              childNode.plz                           = firmenstandortData.firmenstandort.plz ?? '';
              childNode.ort                           = firmenstandortData.firmenstandort.ort ?? '';
              childNode.laendercode                   = firmenstandortData.firmenstandort.laendercode ?? 'DE';
            }
            pcAdressenList.push(childNode);
          })
          pcAdressenList.sort((a, b) => (a.nlCode) ? 1 : -1);
          resultNode.pcAdressen = pcAdressenList;
          resultNodeList.push(resultNode);
        })

        let hauptstandortNodeList: FirmenstandortElement[] = resultNodeList.filter(firmenstandort => firmenstandort.istFirmenhauptstandort);
        let andereStandorteNodeList: FirmenstandortElement[] = resultNodeList.filter(firmenstandort => !firmenstandort.istFirmenhauptstandort);

        if (andereStandorteNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).length == 0) {
          hauptstandortNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).forEach(firmenstandort => {
            if (firmenstandort.pcAdressen && firmenstandort.pcAdressen.length == 1) {
              firmenstandort.pcAdressen[0].canBeMoved = true;
            }
          });
        }
        this.hauptstandortDataSource = new MatTableDataSource(hauptstandortNodeList);
        this.updatePcAdresseActions(this.hauptstandortDataSource);

        andereStandorteNodeList.sort((a, b) => (a.istGeloescht) ? 1 : -1);
        andereStandorteNodeList.filter(firmenstandort => !firmenstandort.istGeloescht).forEach(firmenstandort => {
          if (firmenstandort.pcAdressen && firmenstandort.pcAdressen.length == 1 && !firmenstandort.istGeloescht) {
            if (!firmenstandort.pcAdressen[0].canBeMoved) {
              firmenstandort.pcAdressen[0].canBeMoved = true;
            }
          }
        });
        this.firmenstandortDataSource = new MatTableDataSource(andereStandorteNodeList);
        this.updatePcAdresseActions(this.firmenstandortDataSource);

        if (hauptstandortNodeList) {
          this.expandedHauptstandortElement = hauptstandortNodeList[0];
        }

        if (andereStandorteNodeList) {
          this.expandedElement = andereStandorteNodeList[0];
        }
      }
    });
  }

  updatePcAdresseActions(datasource: MatTableDataSource<FirmenstandortElement>) {
    datasource.data.forEach(node => {
      if (!node.istGeloescht) {
        node.pcAdressen?.forEach(pcAdresse => {
          if (pcAdresse.canBeMoved) {
            pcAdresse.actions.push(
              {
                label: 'PC Adresse neu zuordnen',
                styleClass: 'bg-gradient-primary',
                iconClass: 'fas fa-exchange-alt',
                functionCall: this.openPcAdresseNeuZuordnenModal,
              },
            )
          }
        });
      }
    })
  };

  updateResultList() {
    this.showAlsoDeletedElements = !this.showAlsoDeletedElements;
    this.filterString = `includeGeloeschte eq ${this.showAlsoDeletedElements}`;
    this.retrieveFirmaData();
  }

  toggleRow(element: FirmenstandortElement) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  toggleTransactionsRow(element: FirmenstandortElement, event: any) {
    if (element.transactions && element.transactions.length > 0) {
      element.transactions = [];
    } else {
      this.firmenstandorteService.getFirmenstandortTransactions(Number(element.firmenstandortId), 5, 0)
          .subscribe(response => {
            if (response) {
              let transactionsList: TransactionDto[] = [];
              response.forEach(transaction => {
                let transactionDto: TransactionDto = {
                  uhrzeit:        transaction.ausgefuehrtAm,
                  datum:          transaction.ausgefuehrtAm,
                  transactionId:  transaction.id,
                  aktion:         transaction.ausgefuehrteAktionen.replace(/\. /g, "\n"),
                  user:           transaction.ausgefuehrtVon,
                  kommentar:      transaction.kommentar,
                }
                transactionsList.push(transactionDto);
              });
              element.transactions = transactionsList;
            }
          });
    }
  }

  seeCompleteHistory(data: FirmenstandorteIndexResultElement) {
    return this.router.navigate([`firma/${this.firmenId}/historie/${data.firmenstandortId}`]);
  }

  toggleHauptstandortRow(element: FirmenstandortElement) {
    this.expandedHauptstandortElement = this.expandedHauptstandortElement === element ? null : element;
  }

  alsHauptstandortDeklarieren(event: Event, data: any): void {
    if (this.firmenId) {
      let newFirmehauptstandort: NewFirmenHauptstandortDto = {
        firmenstandorteId: data.firmenstandortId,
        zuletztGeaendertVon: this.userEmail,
      }
      this.firmenService.changeFirmenhauptstandort(this.firmenId, newFirmehauptstandort).subscribe(response => {
        this._snackBar.open('Hauptstandort geändert', 'Schließen', { duration: 5000 });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    }
  }


  openEditFirmaDatenModal(event: Event, data: any) {
    if (this.firmenElement) {
      this.editFirmaDatenForm.setValue({
        firmenname:           this.firmenElement.name                 ?? '',
        branchenzuschlag:     this.firmenElement.branchenzuschlag     ?? 'kein Branchenzuschlag',
        branchencodeWz1979:   this.firmenElement.branchencodeWz1979   ?? '',
        branchencodeWz2008:   this.firmenElement.branchencodeWz2008   ?? '',
        lieferantVonBranche:  this.firmenElement.lieferantVonBranche  ?? '0 - To be clarified',
        waehrungscode:        this.firmenElement.waehrungscode        ?? 'EUR',
        webseiteHomepage:     this.firmenElement.webseiteHomepage     ?? '',
      });
      this.editFirmaDatenModal.show();
    }
  }

  editFirmaDaten() {
    if (this.editFirmaDatenForm.status === 'VALID' && this.firmenElement && this.firmenElement.id) {
      this.firmenElement.name = this.editFirmaDatenForm.controls.firmenname.value ?? '';

      this.editFirmaDatenModal.hide();

      this.firmenService.patchFirma(this.firmenElement.id, this.firmenElement).subscribe(
          (response) => {
            this.setAndShowSuccessMessage('Firmendaten');
          },
          (err) => {
            this.setAndShowErrorMessage(err.error.message);
          }
      );
    }
  }

  closeEditFirmaDatenModal() {
    this.editFirmaDatenModal.hide();
  }


  openEditStandortDatenModal(event: Event, data: any) {
    this.currentStandortIsHauptstandort = false;
    if (data.istFirmenhauptstandort) {
      this.currentStandortIsHauptstandort = true;
    }
    this.currentStandortId = data.firmenstandortId;

    this.editStandortDatenForm.setValue({
      strasseUndHausnummer:         data.strasseUndHausnummer,
      plz:                          data.plz,
      ort:                          data.ort,
      laendercode:                  data.laendercode,
      telefon:                      data.telefon                      ?? '',
      fax:                          data.fax                          ?? '',
      email:                        data.email                        ?? '',
      betriebsgroesse:              data.betriebsgroesse              ?? 'ungeklärt',
      betriebsgroesseGewerblich:    data.betriebsgroesseGewerblich    ?? 'ungeklärt',
      betriebsgroesseKaufmaennisch: data.betriebsgroesseKaufmaennisch ?? 'ungeklärt',
    });

    this.editStandortDatenModal.show();
  }

  editStandortDaten() {
    if (this.editStandortDatenForm.status === 'VALID') {
      let firmenStandortElement: FirmenstandortDto;
      for (const firmenStandort of this.firmenStandorte) {
        if (firmenStandort.id === this.currentStandortId) {
          firmenStandortElement = firmenStandort;
          firmenStandortElement.strasseUndHausnummer         = this.editStandortDatenForm.controls.strasseUndHausnummer.value  ?? '';
          firmenStandortElement.plz                          = this.editStandortDatenForm.controls.plz.value                   ?? '';
          firmenStandortElement.ort                          = this.editStandortDatenForm.controls.ort.value                   ?? '';
          firmenStandortElement.laendercode                  = this.editStandortDatenForm.controls.laendercode.value           ?? '';

          this.editStandortDatenModal.hide();

          this.firmenstandorteService.patchFirmenstandort(firmenStandortElement.id, firmenStandortElement).subscribe(
              (response) => {
                this.setAndShowSuccessMessage('Standort-Daten');
              },
              (err) => {
                this.setAndShowErrorMessage(err.error.message);
              }
          );
        }
      }
    }
  }

  closeEditStandortDatenModal() {
    this.editStandortDatenModal.hide();
  }


  openPcAdresseNeuZuordnenModal(event: Event, data: PcAdresseElement) {
    this.currentPcAdresse = data;
    this.selectPcAdresseZuordnenModal.show();
  }

  selectPcAdresseZuordnen(mode: string, type?: string) {
    this.selectPcAdresseZuordnenModal.hide();
    if (mode === 'neue_firma') {
      this.pcAdrMode = 'neue Firma';
      this.openPcAdrNeueFirmaDatenModal();
    }
    else if (mode === 'gleiche_firma') {
      this.pcAdrMode = 'gleiche Firma';
      if (type === 'neuer_standort') {
        this.pcAdrStandortMode = 'neu';
        this.openPcAdrNeuerStandortDatenModal();
      }
      else if (type === 'vorhandener_standort') {
        this.pcAdrStandortMode = 'vorhanden';
        this.openPcAdrVorhandenerStandortDatenModal();
      }
    }
    else if (mode === 'andere_firma') {
      this.pcAdrMode = 'andere Firma';
      if (type === 'neuer_standort') {
        this.pcAdrStandortMode = 'neu';
      }
      else if (type === 'vorhandener_standort') {
        this.pcAdrStandortMode = 'vorhanden';
      }
      this.openPcAdrAndereFirmaDatenModal();
    }
  }

  closePcAdresseZuordnenModal() {
    this.currentPcAdresse = null;
    this.selectPcAdresseZuordnenModal.hide();
  }


  openPcAdrNeueFirmaDatenModal() {
    if (this.currentPcAdresse) {
      this.pcAdrNeueFirmaDatenForm.setValue({
        firmenname:           this.currentPcAdresse.originalFirmenname    ?? '',
        strasseUndHausnummer: this.currentPcAdresse.strasseUndHausnummer  ?? '',
        plz:                  this.currentPcAdresse.plz                   ?? '',
        ort:                  this.currentPcAdresse.ort                   ?? '',
        laendercode:          this.currentPcAdresse.laendercode           ?? 'DE'
      });

      this.pcAdrNeueFirmaDatenModal.show();
    }
  }

  pcAdrNeueFirmaDaten() {
    if (this.pcAdrNeueFirmaDatenForm.status === 'VALID') {
      if (this.currentPcAdresse?.pcAdresseId) {
        const dtoData: PcAdresseUmhaengenDto = {
          zuletztGeaendertVon:                    this.userService.UserName,
          pcAdressenId:                           this.currentPcAdresse?.pcAdresseId,
          firmenstandorteId:                      this.currentPcAdresse?.firmenstandortId,
          zielFirmenName:                         this.pcAdrNeueFirmaDatenForm.controls.firmenname.value ?? undefined,
          zielFirmenstandortStrasseUndHausnummer: this.pcAdrNeueFirmaDatenForm.controls.strasseUndHausnummer.value ?? undefined,
          zielFirmenstandortPlz:                  this.pcAdrNeueFirmaDatenForm.controls.plz.value ?? undefined,
          zielFirmenstandortOrt:                  this.pcAdrNeueFirmaDatenForm.controls.ort.value ?? undefined,
          zielFirmenstandortLaendercode:          this.pcAdrNeueFirmaDatenForm.controls.laendercode.value ?? undefined,
        };

        this.pcAdrNeueFirmaDatenModal.hide();

        this.pcAdressenService.pcAdresseZuordnungNeueFirmaNeuerStandort(dtoData).subscribe(
            (response) => {
              this.setAndShowSuccessMessage('PC-Adresse neue Firma neuer Standort');
            },
            (err) => {
              this.setAndShowErrorMessage(err.error.message);
            }
        );
      }
    }
  }

  closePcAdrNeueFirmaDatenModal() {
    this.pcAdrNeueFirmaDatenModal.hide();
  }


  openPcAdrNeuerStandortDatenModal() {
    if (this.currentPcAdresse) {
      this.pcAdrNeuerStandortDatenForm.setValue({
        strasseUndHausnummer: this.currentPcAdresse.strasseUndHausnummer  ?? '',
        plz:                  this.currentPcAdresse.plz                   ?? '',
        ort:                  this.currentPcAdresse.ort                   ?? '',
        laendercode:          this.currentPcAdresse.laendercode           ?? 'DE'
      });

      this.pcAdrNeuerStandortDatenModal.show();
    }
  }

  savePcAdrNeuerStandortDaten() {
    if (this.pcAdrNeuerStandortDatenForm.status === 'VALID' && this.currentPcAdresse?.pcAdresseId) {
        let dtoData: PcAdresseUmhaengenDto = {
          zuletztGeaendertVon:                    this.userService.UserName,
          pcAdressenId:                           this.currentPcAdresse?.pcAdresseId,
          firmenstandorteId:                      this.currentPcAdresse?.firmenstandortId,
          zielFirmenId:                           this.currentPcAdresse?.firmenId,
          zielFirmenstandorteId:                  this.currentPcAdresse?.firmenstandortId,
          zielFirmenName:                         this.currentPcAdresse?.firmenname,
          zielFirmenstandortStrasseUndHausnummer: this.pcAdrNeuerStandortDatenForm.controls.strasseUndHausnummer.value ?? undefined,
          zielFirmenstandortPlz:                  this.pcAdrNeuerStandortDatenForm.controls.plz.value ?? undefined,
          zielFirmenstandortOrt:                  this.pcAdrNeuerStandortDatenForm.controls.ort.value ?? undefined,
          zielFirmenstandortLaendercode:          this.pcAdrNeuerStandortDatenForm.controls.laendercode.value ?? undefined,
          kommentar:                              ''
        };

        if (this.pcAdrMode === 'andere Firma' && this.currentSelectedFirmenId && this.currentSelectedFirmenstandorteId) {
          dtoData.zielFirmenId          = this.currentSelectedFirmenId;
          dtoData.zielFirmenstandorteId = this.currentSelectedFirmenstandorteId;
        }

        this.pcAdrNeueFirmaDatenModal.hide();

        this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaNeuerStandort(dtoData).subscribe(
            (response) => {
              this.setAndShowSuccessMessage('PC-Adresse neuer Standort');
            },
            (err) => {
              console.log('err', err);
              this.setAndShowErrorMessage(err.error.message);
            }
        );
    }
  }

  closePcAdrNeuerStandortDatenModal() {
    this.pcAdrNeuerStandortDatenModal.hide();
  }


  openPcAdrVorhandenerStandortDatenModal() {
    if (this.firmenId || this.currentSelectedFirmenId) {
      const firmenId = this.currentSelectedFirmenId ?? this.firmenId;
      this.firmenService.getFirmenstandorteByFirmenId(firmenId, 'includeGeloeschte eq false').subscribe(result => {
        if (result) {
          let otherFirmenstandorteList = result.filter(element => element.id != this.currentPcAdresse?.firmenstandortId);

          this.pcAdrVorhandeneStandorteDataSource = new MatTableDataSource(otherFirmenstandorteList);
          this.pcAdrVorhandeneStandorteListLength = otherFirmenstandorteList.length ?? 0;

          this.pcAdrVorhandenerStandortDatenModal.show();

          // Trigger a change detection cycle by calling `detectChanges()`
          this.cd.detectChanges();

          // Wrap the sorting and paginator initialization in setTimeout
          setTimeout(() => {
            this.pcAdrVorhandeneStandorteDataSource.sort = this.sort;
            this.pcAdrVorhandeneStandorteDataSource.paginator = this.paginator;

            // Updating paginator after data change
            if (this.pcAdrVorhandeneStandorteDataSource.paginator) {
              this.pcAdrVorhandeneStandorteDataSource.paginator.firstPage();
            }
          });
        }
      });
    }
  }

  selectPcAdrVorhandenerStandort(row: FirmenstandortDto) {
    this.currentSelectedStandort = row;
    this.currentSelectedFirmenstandorteId = Number(row.id);
    this.currentSelectedFirmenId = Number(row.firmenId);
  }

  savePcAdrVorhandenerStandortDaten() {
    if (this.currentSelectedStandort && this.currentPcAdresse?.pcAdresseId) {

      let dtoData: PcAdresseUmhaengenDto = {
        zuletztGeaendertVon:                    this.userService.UserName,
        pcAdressenId:                           this.currentPcAdresse?.pcAdresseId,
        firmenstandorteId:                      this.currentPcAdresse?.firmenstandortId,
        zielFirmenId:                           this.currentPcAdresse?.firmenId,
        zielFirmenstandorteId:                  this.currentSelectedStandort?.id,
        zielFirmenName:                         this.currentPcAdresse?.firmenname,
        zielFirmenstandortStrasseUndHausnummer: this.currentPcAdresse?.strasseUndHausnummer ?? undefined,
        zielFirmenstandortPlz:                  this.currentPcAdresse?.plz ?? undefined,
        zielFirmenstandortOrt:                  this.currentPcAdresse?.ort ?? undefined,
        zielFirmenstandortLaendercode:          this.currentPcAdresse?.laendercode ?? undefined,
        kommentar:                              ''
      };

      if (this.pcAdrMode === 'andere Firma' && this.currentSelectedFirmenId && this.currentSelectedFirmenstandorteId) {
        dtoData.zielFirmenId          = this.currentSelectedFirmenId;
        dtoData.zielFirmenstandorteId = this.currentSelectedFirmenstandorteId;
      }

      this.pcAdrVorhandenerStandortDatenModal.hide();

      this.pcAdressenService.pcAdresseZuordnungVorhandeneFirmaVorhandenerStandort(dtoData).subscribe(
          (response) => {
            this.setAndShowSuccessMessage('PC-Adresse anderer Standort');
          },
          (err) => {
            this.setAndShowErrorMessage(err.message);
          }
      );
    }
  }

  closePcAdrVorhandenerStandortDatenModal() {
    this.pcAdrVorhandenerStandortDatenModal.hide();
  }


  openPcAdrAndereFirmaDatenModal() {
    this.currentSelectedFirmenId          = null;
    this.currentSelectedFirmenstandorteId = null;
    this.pcAdrAndereFirmaSuchForm.controls['searchFirmenname'].setValue('');
    this.pcAdrAndereFirmaSuchForm.controls['searchFirmenId'].setValue('');
    this.pcAdrAndereFirmaSuchForm.controls['pcAdrAndereFirmaSelected'].setValue([]);

    this.pcAdrAndereFirmaResultListLength = 0;
    this.pcAdrAndereFirmaDataSource       = new MatTableDataSource();

    this.pcAdrAndereFirmaDatenModal.show();
  }

  getPcAdrAndereFirmen(skip: number) {
    if (this.pcAdrAndereFirmaSuchForm.value.searchFirmenname) {
      this.firmenService.getFirmen(`${this.pcAdrAndereFirmaSuchForm.value.searchFirmenname}*`, 'firmenname',
          'any', 'full', 'search.score() desc,firmenname', 5,
          skip, true, 'includeGeloeschte eq false')
          .subscribe(result => {
            if (result) {
              this.pcAdrAndereFirmaResultListLength = result['@odata.count'];
              this.pcAdrAndereFirmaDataSource = new MatTableDataSource(result.value);
            }
          })
    }
    else if (this.pcAdrAndereFirmaSuchForm.value.searchFirmenId) {
      this.firmenService.getFirmen(`${this.pcAdrAndereFirmaSuchForm.value.searchFirmenId}`, 'firmenId',
          'any', 'full', 'search.score() desc,firmenname', 5,
          skip, true, 'includeGeloeschte eq false')
          .subscribe(result => {
            if (result) {
              this.pcAdrAndereFirmaResultListLength = result['@odata.count'];
              this.pcAdrAndereFirmaDataSource = new MatTableDataSource(result.value);
            }
          })
    }
  }

  getPcAdrAndereFirmenPageData(event: PageEvent) {
    let skip = event.pageIndex * this.pcAdrAndereFirmaPageSize;
    this.getPcAdrAndereFirmen(skip);
  }

  selectPcAdrAndereFirma(row: FirmenIndexFirmaDto) {
    if (row.firmenId) {
      this.currentSelectedFirmenId = Number(row.firmenId);
    }
  }

  closePcAdrAndereFirmaDatenModal() {
    this.pcAdrAndereFirmaDatenModal.hide();
  }


  setAndShowSuccessMessage(mode: string): void {
    if (mode === 'Firmendaten') {
      this.successMsg = 'Die Firmen-Daten wurden gespeichert.';

    } else if (mode === 'Standort-Daten') {
      this.successMsg = 'Die Standort-Daten wurden gespeichert.';

    } else if (mode === 'PC-Adresse neue Firma neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer neuen Firma und einem neuen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse andere Firma neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer vorhandenen Firma und einem neuen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse andere Firma anderer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einer vorhandenen Firma und einem anderen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse anderer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einem anderen Standort zugeordnet.';

    } else if (mode === 'PC-Adresse neuer Standort') {
      this.successMsg = 'Die PC-Adresse wurde einem neuen Standort zugeordnet.';

    }

    this.successModal.show();
  }

  setAndShowErrorMessage(errorMsg: string): void {
    this.errorMsg = "Die Daten konnten nicht gespeichert werden. <br><br>Fehlermeldung:<br><i>" + errorMsg + "</i>";
    this.errorModal.show();
  }

  closeSuccessModal() {
    this.successModal.hide();
    window.location.reload();
  }

  closeErrorModal() {
    this.errorModal.hide();
  }

  sortData(data: any) {
    data.sort = this.sort;
  }

  back() {
    this.router.navigate(['/firmen']).catch();
  }
}
